import axios from "./../../config/axios";

function findByID(id) {
    return axios().get(`/purchase/invoices/${id}`);
}

function print(data) {
    return axios().get(`/purchase/invoices/${data.id}`, {
        headers: {
            "Accept": "text/html"
        }
    });
}

function create(data) {
    return axios().post("/purchase/invoices", data, {
        headers: {
            "X-Request-ID": data.idempotentKey
        }
    });
}

function update(data) {
    return axios().put(`/purchase/invoices/${data.id}`, data);
}
function remove(data) {
    return axios().delete(`/purchase/invoices/${data.id}`);
}
function index(params) {

    params = {...params, limit: params.itemsPerPage, offset: (params.page - 1) * params.itemsPerPage};

    return axios().get("/purchase/invoices", {
        params
    })
}

function post(data) {
    return axios().put(`/purchase/invoices/${data.id}/post`)
}
function states() {
    return axios().get('/purchase/invoice-states')
}
export default {
    findByID,
    create,
    update,
    remove,
    index,
    post,
    print,
    states
}